// extracted by mini-css-extract-plugin
module.exports = {"wave2DetailL":"L_wave2DetailL__5rlnz"};